module.exports = __webpack_public_path__ + "static/media/1.3e09548c.png";